var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","small":"","title":"Marcar como no visto","loading":_vm.load_visto},on:{"click":_vm.nover_postulante}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("fas fa-eye-slash")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }